<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="'Penilaian '+title">
            <br>
            <common-training-header :withUser="true" :penilai="penilai"/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.attendants"
                rowKey="hash"
                :loading="loading"
                :pagination="false"
                bordered>

                <a-table-column key="name" title="Nama Peserta" align="center">
                    <div slot-scope="record" style="text-align: left">
                        {{ record.name }}
                    </div>
                </a-table-column>

                <a-table-column key="notulen" title="Notulen" align="center">
                    <div slot-scope="record" style="text-align: center">
                        <a-tooltip title="Notulen">
                            <a-button 
                                :style="'width: 35px;background-color: ' + (record.activities[0].is_notulen_present ? '#87d068' : '#989696')"
                                @click="items.evaluator.is_note_taker ? notulen(record.hash, 'input') : notulen(record.hash, 'report')"
                                :disabled="record.activities[0].presentation_file == null || record.activities[0].presentation_outline_file == null"
                                icon="file-text"
                                size="small" ></a-button>
                        </a-tooltip>
                    </div>
                </a-table-column>

                <a-table-column key="charter" title="Dokumentasi Project" v-if="outline === 'project_evaluation'" align="center">
                    <template slot-scope="record">
                        <a-tooltip title="Dokumentasi Project">
                            <a-button
                                style="margin-left: 4px;"
                                size="small"
                                icon="file-zip"
                                v-if="record.documents_filled"
                                @click="charter(record.hash)"
                            />
                        </a-tooltip>
                    </template>
                </a-table-column>

                <a-table-column-group>
                    <span slot="title">Penilaian {{ title }}</span>
                    <a-table-column :key="activity.hash" :title="toPascalCase(activity.name)" v-for="activity in this.arrActivityProposal" className="column-center">
                        <template slot-scope="record">
                            <div v-if="arrFilter(record.activities[0].scores, activity.hash).length > 0">
                                <div v-for="scorePaper in arrFilter(record.activities[0].scores, activity.hash)" :key="scorePaper.id">
                                    <center v-if="scorePaper.scoreable.hash == activity.hash">
                                        <a-tag color="#87d068" @click="addScoring(record.hash, activity.name, activity.hash)" style="align: left; cursor: pointer;">
                                            {{ scorePaper.raw_score }}
                                        </a-tag>
                                    </center>
                                </div>
                            </div>
                            <center v-else>
                                <a-button
                                    size="small"
                                    type="danger"
                                    @click="addScoring(record.hash, activity.name, activity.hash)"
                                    :disabled="isDisabled(record.activities[0], record)"
                                >
                                </a-button>
                            </center>
                        </template>
                    </a-table-column>
                </a-table-column-group>

                <a-table-column key="recap" title="Nilai Total" align="center">
                    <template slot-scope="record">
                        <center>
                            {{ getRecapScore(record.activities[0].scores) }}
                        </center>
                    </template>
                </a-table-column>

                <a-table-column-group>
                    <span slot="title">File</span>
                    <a-table-column key="presentation_file" title="Presentasi" align="center">
                        <template slot-scope="record">
                            <a-button type="link" size="small" @click="download(getFile(record.activities[0]))" v-show="record.activities[0].revision_file || record.activities[0].presentation_file">
                                <a-icon type="file-ppt" theme="twoTone" two-tone-color="#eb3437" />
                            </a-button>
                        </template>
                    </a-table-column>

                    <a-table-column key="presentation_outline_file" :title="title" align="center">
                        <template slot-scope="record">
                            <a-button type="link" size="small" @click="download(getOutlineFile(record.activities[0]))" v-show="record.activities[0].revision_outline_file || record.activities[0].presentation_outline_file">
                                <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" />
                            </a-button>
                        </template>
                    </a-table-column>
                </a-table-column-group>
            </a-table>
        </a-card>
    </div>
</template>

<style>
th.column-center {
    text-align: center !important;
}
</style>

<script>
    export default {
        props: {
            outline: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                items: [],
                loading: false,
                penilai: 0,
                arrActivityProposal: []
            }
        },
        created() {
            this.getItems()
        },
        computed: {
            activeModule() {
                return this.$laravel.active_module
            },
            title(){
                switch(this.outline) {
                    case "proposal":
                        return "Proposal"
                    case "project_evaluation":
                        return "Evaluasi Project"
                    default:
                        return "Makalah"
                }
            },
        },
        watch: {
            items: function(value) {
                if(value.evaluator){
                    this.penilai = value.evaluator.evaluator_number
                }
            }
        },
        methods: {
            notulen(user_hash, identity){
                let params = {
                    user_hash: user_hash,
                    identity: identity,
                    previous: this.getRoute()
                }

                if(this.outline == 'paper'){
                    window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.notulen.form') + '?' + this.$qs.stringify(params)
                }else{
                    console.log('admin.' + this.activeModule.module.identifier + '.notulen.' + this.outline + '.form')
                    window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.notulen.' + this.outline + '.form') + '?' + this.$qs.stringify(params)
                }
            },
            charter(id){
                let params = {
                    attendant: id
                }

                window.location.href = this.routeUri('admin.project.documentation') + '?' + this.$qs.stringify(params)
            },
            getItems() {
                this.loading = true

                let params = {}

                if(this.outline !== 'paper'){
                    params = {
                        outline: this.outline
                    }
                }

                this.$http
                    .get(this.routeUri('api.activity-scoring.attendants') + '?' + this.$qs.stringify(params))
                    .then(response => {
                        this.items = response.data

                        this.items.activity_aspects.forEach(activityAspect => {
                            if(this.outline === 'proposal'){
                                if(activityAspect.code === 'PRJ-PRO' || activityAspect.code === 'PRJ-PRE'){
                                    this.arrActivityProposal.push({
                                        hash: activityAspect.hash,
                                        name: activityAspect.name
                                    })
                                }
                            }else if(this.outline === 'project_evaluation'){
                                if(activityAspect.code === 'PRJ-IMP' || activityAspect.code === 'PRJ-FOU' || activityAspect.code === 'PRJ-EVA'){
                                    this.arrActivityProposal.push({
                                        hash: activityAspect.hash,
                                        name: activityAspect.name
                                    })
                                }
                            }else{
                                this.arrActivityProposal.push({
                                    hash: activityAspect.hash,
                                    name: activityAspect.name
                                })
                            }
                        })
                    })
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false))
            },
            addScoring(userHash, subTitle, catHash) {
                let params = {
                    user_hash: userHash,
                    sub_title: subTitle,
                    cat_hash: catHash
                }

                if(this.outline == 'paper') {
                    window.location.href = this.routeUri('admin.paper.scoring.store') + '?' + this.$qs.stringify(params)
                }else if(this.outline == 'proposal'){
                    window.location.href = this.routeUri('admin.project.scoring.store') + '?' + this.$qs.stringify(params)
                }else{
                    window.location.href = this.routeUri('admin.project.scoring.evaluation.store') + '?' + this.$qs.stringify(params)
                }
            },
            arrFilter(scores, paper){
                let newArr = scores.filter(function(ele){
                    return (ele.scoreable.hash == paper)
                })
                return newArr
            },
            toPascalCase(string){
                return string.replace(/(\w)(\w*)/g, function(g0,g1,g2){
                    return g1.toUpperCase() + g2.toLowerCase()
                })
            },
            download(url) {
                window.open(window.location.origin + url, '_blank')
            },
            getRecapScore(scores){
                if(Array.isArray(scores) && scores.length > 0){
                    let recap = 0
                    let idx = 0
                    scores.forEach(score => {
                        if(this.outline === 'proposal'){
                            if(score.scoreable.scoreable_type === 'aspect'){
                                if(score.scoreable.code === 'PRJ-PRO' || score.scoreable.code === 'PRJ-PRE'){
                                    recap = parseFloat(recap) + parseFloat(score.raw_score)
                                    idx++
                                }
                            }
                        }else if(this.outline === 'project_evaluation'){
                            if(score.scoreable.scoreable_type === 'aspect'){
                                if(score.scoreable.code === 'PRJ-IMP' || score.scoreable.code === 'PRJ-FOU' || score.scoreable.code === 'PRJ-EVA'){
                                    recap = parseFloat(recap) + parseFloat(score.raw_score)
                                    idx++
                                }
                            }
                        }else{
                            if(score.scoreable.scoreable_type === 'aspect'){
                                recap = parseFloat(recap) + parseFloat(score.raw_score)
                                idx++
                            }
                        }
                    })

                    if(isNaN(recap / idx)){
                        return 0
                    }else{
                        return parseFloat(recap / idx).toFixed(2)
                    }
                }
                return 0
            },
            isDisabled(activities, record){
                if(this.outline === 'project_evaluation' && !record.documents_filled)
                    return true

                if(activities.presentation_file === null || activities.presentation_outline_file === null){
                    return true
                }

                return false
            },
            getFile(activities){
                if(activities.revision_file){
                    return activities.revision_file
                }else{
                    return activities.presentation_file
                }
            },
            getOutlineFile(activities){
                if(activities.revision_outline_file){
                    return activities.revision_outline_file
                }else{
                    return activities.presentation_outline_file
                }
            }
        }
    }
</script>
